export default "__VITE_ASSET__035e9dbc__"